// extracted by mini-css-extract-plugin
export default {"profileIconSquare":"ProfileIconSquare_profileIconSquare__rDIiJ","iconSquare":"ProfileIconSquare_iconSquare__+fV3L","label":"ProfileIconSquare_label__xfPP8"};